import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'
import { catalogApi } from '@/services/catalog.service';


export default /*@__PURE__*/_defineComponent({
  __name: 'CategoriesHeaderMenu',
  props: {
    isActive: { type: Boolean },
    rootCategories: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props

const isActiveId = ref(null)

const menu = ref([])

async function getAllMenu() {
  const { item } = await catalogApi.categories.menu.execute()
  menu.value = item
}
getAllMenu()

const menus = ref(new Map())
const activeMenu = ref(null)

watch(() => props.isActive, (newVal) => {
  onRootMouseenter(props.rootCategories[0].id)
})


async function getNestedMenu(id) {
  if (menus.value.has(id)) {
    return menus.value.get(id)
  }
  const item = menu.value.find((el) => el.id === id).children
  menus.value.set(id, item)
  return item
}

async function onRootMouseenter(id) {
  isActiveId.value = id
  activeMenu.value = await getNestedMenu(id)
}


const __returned__ = { props, isActiveId, menu, getAllMenu, menus, activeMenu, getNestedMenu, onRootMouseenter, ref, watch, get catalogApi() { return catalogApi } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})